module.exports = __webpack_public_path__ + "img/lib_region_flag_je.760e195f.png";